import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'

const OrderItemUpdateModalUI = ({ context, messageList, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // item name
  itemName,
  // quantity
  quantity, onQuantityChange, quantityError, setQuantityError,
  // price
  price, onPriceChange, priceError, setPriceError,
  // due date
  dueDate, onDueDateChange, dueDateError, setDueDateError
}) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_update_order_item'
    buttonMessageKey='c_update'
    cancelMessageKey='c_cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF name='productItemId' required={true}
      messageList={messageList} labelKey='c_product'
      value={itemName} disabled={true}
    />
    <InputTextSF type='positive_integer' name='quantity' required={true} maxLength={5}
      messageList={messageList} labelKey='c_quantity'
      value={quantity} onChange={onQuantityChange}
      error={quantityError} setError={setQuantityError}
    />
    <InputTextSF type='price' name='price' required={true} maxLength={13}
      messageList={messageList} labelKey='c_price'
      value={price} onChange={onPriceChange}
      error={priceError} setError={setPriceError}
    />
    <InputDateUI context={context} name='dueDate'
      messageList={messageList} labelKey='c_due_date'
      selectedDateISO={dueDate} onChange={onDueDateChange}
      error={dueDateError} setError={setDueDateError}
    />
  </ModalFormUI>

export default OrderItemUpdateModalUI
